import React, { createContext, useContext, useEffect, useRef } from "react"
import JWTApi, { IUser } from "../../libs/login/JWTApi"
import useLoginDlg from "./LoginDlg"

type TLoginContext = {
    login:(onLogin?:Function) => void
    logout:() => void
}

interface TLoginContextProps {
    api:JWTApi
    children:JSX.Element
    required?:boolean
    onAuth?:(user:IUser) => void
}

const LoginContext = createContext<TLoginContext>({} as any)
export const useLogin = () => useContext(LoginContext)

export default function LoginProvider(props:TLoginContextProps) {
    const {api,children,required,onAuth} = props
    const {showLogin,hideLogin} = useLoginDlg()

    const login = (onLogin?:Function) => showLogin(api, !!required, onLogin)

    const _onAuth = async (user:IUser|null) => {
        if (!user && required) login()
        else if (!!user) {
            hideLogin()
            onAuth?.(user)
        }
    }

    const logout = () => api.logout()

    useEffect(() => {
        api.onAuth(_onAuth)
        api.auth()
        return () => { api.removeListener("auth", _onAuth) }
    }, [])

    return <LoginContext.Provider value={{login,logout}}>
        {children}
    </LoginContext.Provider>
}